import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { GET_PROJECT } from '../constants/routesNames';
import ReactGA from 'react-ga';
import ScrollView, { ScrollElement } from './ScrollVIew';

export class ProjectList extends Component {
  componentDidMount() {
    const {projectSelected} = this.props;

    if (projectSelected) {
      setTimeout(() => this.scroller.scrollTo(projectSelected.key), 500);
    }
  }

  handleProjectClick(slug) {
    ReactGA.event({
      category: 'Project List',
      action: 'Click Project'
    });

    this.scroller.scrollTo(slug);
  }

  renderList() {
    const { projects, projectSelected } = this.props;
    let projectsKeys = Object.keys(projects);

    return projectsKeys.map(slug => {
      const selected = !!projectSelected && slug === projectSelected.key;
      return (
        <ScrollElement key={slug} name={slug}>
          <div
            className="project-thumb-wrapper"
            id={'wrapper-' + slug}
            key={slug}
          >
            <Link
              to={GET_PROJECT(slug)}
              onClick={() => this.handleProjectClick(slug)}
              className={classnames(
                'project-thumb',
                { selected },
                !projectSelected ? 'color' : null
              )}
            >
              <img src={projects[slug].cover} />
            </Link>
          </div>
        </ScrollElement>
      );
    });
  }

  render() {
    return (
      <ScrollView ref={scroller => (this.scroller = scroller)}>
        <div id="project-list" ref={r => (this.list = r)}>
          {this.renderList()}
        </div>
      </ScrollView>
    );
  }
}

ProjectList.propTypes = {
  projectSelected: PropTypes.object,
  projects: PropTypes.object
};

const mapStateToProps = state => {
  return {
    projects: state.projects.data
  };
};

export default connect(mapStateToProps)(ProjectList);



// WEBPACK FOOTER //
// ./src/components/ProjectList.js